// Reusable bullet dot + a ready-made bulleted list item.
//
// `Bullet` is a small, properly-sized dot (not a text glyph). It inherits the current text
// color via `bg-current`, so it tints with its context — e.g. it turns green inside an
// "Output" block. Size/opacity are tunable via `className`.
//
// `Point` is a bullet + wrapping text row, aligned so the dot sits on the first line. Use it
// for short "points" lists (the workflow Input/Output values today; reusable on the skill page).

export function Bullet({ className = "", size = "h-[5px] w-[5px]" }: { className?: string; size?: string }) {
  return <span aria-hidden className={`${size} shrink-0 rounded-full bg-current ${className}`} />;
}

export function Point({ children, className = "" }: { children: React.ReactNode; className?: string }) {
  return (
    <div className={`flex items-start gap-2 ${className}`}>
      <Bullet className="mt-[6px] opacity-55" />
      <span className="min-w-0 [overflow-wrap:anywhere]">{children}</span>
    </div>
  );
}
